import { REVISION_POLICY_LINES } from '../../types/orderPolicy';
import styles from './RevisionPolicyNotice.module.scss';

interface RevisionPolicyNoticeProps {
  className?: string;
}

// 주문 접수 단계에서 시안 무료 수정 횟수와 추가 비용 정책을 안내한다
function RevisionPolicyNotice({ className }: RevisionPolicyNoticeProps) {
  return (
    <div className={`${styles.notice} ${className ?? ''}`} role="note">
      <strong className={styles.title}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4M12 16h.01" />
        </svg>
        시안 수정 안내
      </strong>
      <ul>
        {REVISION_POLICY_LINES.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  );
}

export default RevisionPolicyNotice;
